if (!customElements.get('elia-collection-filters')) {
  customElements.define('elia-collection-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.onHistory = () => this.update(new URL(location.href), false);
      window.addEventListener('popstate', this.onHistory);
      this.addEventListener('click', e => {
        const opener = e.target.closest('[data-filter-open]');
        if (opener) {
          this.openerKey = opener.dataset.filterOpen;
          this.snapshot();
          const wide = window.matchMedia('(min-width: 990px)').matches;
          const groups = [...this.dialog.querySelectorAll('details')];
          const kind = d => d.dataset.kKind || '';
          groups.forEach(d => {
            if (this.openerKey === 'all') d.open = kind(d) === 'size' || (wide && kind(d) === 'color');
            else d.open = d.dataset.filterGroup === this.openerKey;
          });
          this.lockedOverflow = document.body.style.overflow;
          this.dialog.showModal(); document.body.style.overflow = 'hidden';
          this.dialog.querySelector('.filter-body').scrollTop = 0;
          const target = this.openerKey !== 'all' && this.dialog.querySelector('details[open]');
          if (target) target.scrollIntoView({ block: 'nearest' });
          (this.dialog.querySelector('details[open] summary') || this.dialog.querySelector('.filter-close')).focus();
          this.dispatchEvent(new CustomEvent('k2:preview', { bubbles: true }));
        }
        if (e.target.closest('.filter-close')) this.cancel();
        const remove = e.target.closest('[data-filter-remove]');
        if (remove && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) { e.preventDefault(); this.update(new URL(remove.href)); }
        if (e.target.closest('[data-filter-reset]')) {
          this.form.querySelectorAll('input[type=checkbox]').forEach(i => i.checked = false);
          this.form.querySelectorAll('input[type=number]').forEach(i => i.value = '');
          this.submitFilters();
        }
        if (e.target === this.dialog) {
          const r = this.dialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.cancel();
        }
      });
      this.addEventListener('input', e => {
        if (!e.target.closest('form')) return;
        // K2c: izbor u panelu je privremen; primenjuje se tek na „Prikaži N proizvoda”.
        this.showError('');
        this.dispatchEvent(new CustomEvent('k2:preview', { bubbles: true }));
      });
      this.addEventListener('change', e => {
        if (!e.target.matches('[data-toolbar-sort]')) return;
        this.form.querySelectorAll('[name=sort_by]').forEach(i => i.checked = i.value === e.target.value);
        this.submitFilters();
      });
      this.addEventListener('submit', e => { e.preventDefault(); this.finish(); });
      this.bindDialog();
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onHistory); this.abort?.abort(); clearTimeout(this.priceTimer); if(this.dialog?.open)document.body.style.overflow=this.lockedOverflow || ''; }
    get dialog() { return this.querySelector('dialog'); }
    get form() { return this.querySelector('form'); }
    bindDialog() {
      this.dialog.addEventListener('cancel', e => { e.preventDefault(); this.cancel(); });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.lockedOverflow || '';
        [...this.querySelectorAll('[data-filter-open]')].find(b => b.dataset.filterOpen === this.openerKey)?.focus();
      });
    }
    showError(message) {
      this.querySelectorAll('.filter-error').forEach(e => { e.textContent = message; e.hidden = !message || (e.classList.contains('filter-request-error') && this.dialog.open); });
    }
    submitFilters() {
      clearTimeout(this.priceTimer);
      const lo = this.form.querySelector('[data-price-min]'), hi = this.form.querySelector('[data-price-max]');
      if (!this.form.checkValidity() || (lo?.value && hi?.value && Number(lo.value) > Number(hi.value))) {
        this.showError('Proveri raspon cene: iznos „Od” ne sme biti veći od iznosa „Do”.'); return Promise.resolve(false);
      }
      const url = new URL(location.href); url.search = '';
      for (const [key, value] of new FormData(this.form)) if (value !== '') url.searchParams.append(key, value);
      return this.update(url);
    }
    snapshot() {
      this.saved = [...this.form.elements].filter(i => i.name).map(i => [i, i.checked, i.value]);
    }
    cancel() {
      (this.saved || []).forEach(([i, checked, value]) => { if (i.type === 'checkbox' || i.type === 'radio') i.checked = checked; else i.value = value; });
      this.showError('');
      this.dialog.close();
    }
    async finish() {
      if (await this.submitFilters()) this.dialog.close();
    }
    async update(url, push = true) {
      this.abort?.abort(); const controller = this.abort = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      const grid = document.getElementById('ProductGridContainer');
      grid.setAttribute('aria-busy', 'true'); this.showError('');
      const request = new URL(url); request.searchParams.set('section_id', this.dataset.section);
      try {
        const response = await fetch(request.href, { signal: controller.signal });
        if (!response.ok) throw new Error('Request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (this.abort !== controller) return false;
        const next = doc.querySelector('elia-collection-filters'), nextGrid = doc.getElementById('ProductGridContainer');
        if (!next || !nextGrid) throw new Error('Incomplete section');
        const wasOpen = this.dialog.open, scroll = this.dialog.querySelector('.filter-body').scrollTop;
        const expanded = [...this.querySelectorAll('details[open]')].map(d => d.dataset.filterGroup);
        const focused = document.activeElement, focusName = focused?.name, focusValue = focused?.value;
        const focusGroup = focused?.closest('details')?.dataset.filterGroup;
        const toolbarFocused = focused?.matches('[data-toolbar-sort]');
        this.innerHTML = next.innerHTML; this.bindDialog();
        grid.innerHTML = nextGrid.innerHTML;
        grid.querySelectorAll('.scroll-trigger').forEach(e => e.classList.add('scroll-trigger--cancel'));
        if (push && url.href !== location.href) history.pushState({}, '', url.pathname + url.search);
        this.querySelectorAll('details').forEach(d => d.open = expanded.includes(d.dataset.filterGroup));
        if (wasOpen) {
          this.dialog.showModal(); document.body.style.overflow = 'hidden';
          const field = [...this.form.elements].find(i => focusName && i.name === focusName && i.value === focusValue && !i.disabled);
          const group = [...this.querySelectorAll('details')].find(d => d.dataset.filterGroup === focusGroup);
          (field || group?.querySelector('summary') || this.querySelector('.filter-close')).focus({ preventScroll: true });
          this.dialog.querySelector('.filter-body').scrollTop = scroll;
        } else if (toolbarFocused) this.querySelector('[data-toolbar-sort]')?.focus();
        return true;
      } catch (error) {
        if (this.abort === controller) this.showError('Filteri nisu osveženi. Pokušaj ponovo pritiskom na „Prikaži proizvode”.');
        return false;
      } finally {
        clearTimeout(timer);
        if (this.abort === controller) grid.removeAttribute('aria-busy');
      }
    }
  });
}
